import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { createFarm } from "api/Farm";
import { UserContext } from "context/user";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import InputField from "components/Input";
import Button from "components/Button";
import CustomModal from "components/Modal";
import "./index.scss";

const AddFarm = ({
  farm,
  buttonAction,
  setFarmDetails,
  isOpen,
  onClose,
  onRequestClose,
}) => {
  const [farmName, setFarmName] = useState("");
  const { token } = useContext(UserContext);
  const history = useHistory();

  const createNewFarm = async () => {
    if (farm?.properties?.farm_id) {
      history.push({
        pathname: `/farms/${farm.properties.farm_id}`,
        state: { draw: true },
      });
    } else {
      if (!farmName) {
        toast.error("Farm Name is required!");

        return;
      }

      const params = { data: { farm_name: farmName } };
      const newFarm = await createFarm(params, token);
      history.push({
        pathname: `/farms/${newFarm.properties.farm_id}`,
        state: { draw: true },
      });
    }
  };

  const handleCloseModal = () => {
    setFarmName("");
    onClose();
    onRequestClose();
    setFarmDetails("");
  };

  const handleUpload = () => {
    setFarmDetails(farmName);
    setFarmName("");
    buttonAction();
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={handleCloseModal}
      onClose={handleCloseModal}
      size="full"
    >
      <div
        className={`create-farm-modal ${
          farmName === "" && farm ? "-entry" : ""
        }`}
      >
        <h4 className="title">Farm management done right.</h4>
        <InputField
          data-testid="create-new-farm"
          label="Name of farm"
          value={farm?.properties?.farm_name || farmName}
          onChange={(e) => setFarmName(e.target.value)}
          disabled={farm?.properties?.farm_name}
        />
        <div
          className={`button-group ${
            farmName === "" && !farm?.properties?.farm_name ? "-disabled" : ""
          }`}
        >
          <p className="label">How do you want to start your farm?</p>
          <Button
            type="solid"
            color="green"
            onClick={() => createNewFarm()}
            data-testid="add-field"
            label="Draw on map"
            block
            size="large"
          />
          <Button
            type="solid"
            color="green"
            data-testid="import-field"
            label="Import farm from file"
            onClick={() => handleUpload()}
            block
            size="large"
          />
        </div>
      </div>
    </CustomModal>
  );
};

AddFarm.propTypes = {
  buttonAction: PropTypes.func.isRequired,
  setFarmDetails: PropTypes.func,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onRequestClose: PropTypes.func,
  farm: PropTypes.oneOfType([PropTypes.object]),
};

AddFarm.defaultProps = {
  setFarmDetails: () => {},
  onRequestClose: () => {},
  onClose: () => {},
  isOpen: false,
  farm: {},
};

export default AddFarm;
